import React from "react";

import SearchIcon from "../../../assets/icons/icon-search-gray.png";
import CompendioImage from "../../../assets/compendiocartoon.svg";

import * as S from "./styles";
import { BodyG, BodyP, TaglineM } from "../../../styles/stylesTypography";
import { theme } from "../../../styles/theme";

const CompendioSearch = () => {
  return (
    <S.Container>
      <S.Wrapper>
        <BodyG color={theme.colors.gray.Cinza_2} fontWeight={700}>Compêndio agrícola</BodyG>

        <S.Image src={CompendioImage} alt="Compêndio" />

        <BodyP color={theme.colors.gray.Cinza_2}>Consulte os produtos agroquímicos registrados no Brasil</BodyP>

        <S.Button onClick={() => window.location = "/compendio"}>
          <S.Icon src={SearchIcon} alt="Ícone de consulta" />
        
          <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800}>
            CONSULTAR COMPÊNDIO
          </TaglineM>
        </S.Button>
      </S.Wrapper>
    </S.Container>
  );
};
export default CompendioSearch;